/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineLite
} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {SoundPlayer} from "../sound/SoundPlayer";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";


export class SpinStart implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    private _whData:WinterHoardParsedGameData;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }


    public getAnimation(data:ParsedServerData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            if(this._whData.nextMode !== "NORMAL") {
                [0, 1, 2, 3, 4].forEach((rid) => {
                    [0, 1, 2 , 3].forEach((sid) => {
                        const symbol:WinterHoardReelSymbol | null = <WinterHoardReelSymbol> Reels.getSymbol(rid, sid);
                        if(symbol && symbol.symName === "M1") {
                            symbol.playNormalSpine();
                        }
                    });
                });
            }
        });
        tl.add(()=>{

            WinterHoardGameModuleConfig.animatedWinLines.disableBetlineNumbers();

            if(SoundConfig.instance.REELS_SPIN_START) {
                SoundPlayer.playEffect(SoundConfig.instance.REELS_SPIN_START[0]);
            }
        }, "+=0.15");

        return tl;
    }

    public prepare(data:ParsedServerData):void {
        this._whData = <WinterHoardParsedGameData> data;
        //this._numberText.text = "" + data.freespinsLeft;
    }
}